import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Custom BMI icon: Gauge/speedometer with "BMI" text.
 * Matches the exact design from the reference image.
 */
const BmiSvgIcon: React.FC<SvgIconProps> = (props) => (
  <SvgIcon viewBox="0 0 64 64" {...props}>
    <g fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
      {/* Outer gauge arc */}
      <path d="M 8 40 A 24 24 0 0 1 56 40" />

      {/* Ticks (left to right) */}
      <line x1="8" y1="40" x2="14" y2="40" />
      <line x1="15" y1="23" x2="19" y2="27" />
      <line x1="32" y1="16" x2="32" y2="22" />
      <line x1="49" y1="23" x2="45" y2="27" />
      <line x1="56" y1="40" x2="50" y2="40" />

      {/* Hollow Needle (pointer + circle base) */}
      <path d="M 46 20 L 36 43 A 5 5 0 1 1 29 36 Z" />
    </g>
    
    {/* BMI Outline Text */}
    <text x="32" y="60" textAnchor="middle" fontSize="16" fontWeight="900" fontFamily="sans-serif, Arial" fill="none" stroke="currentColor" strokeWidth="2" letterSpacing="1">
      BMI
    </text>
  </SvgIcon>
);

export default BmiSvgIcon;
